import { Trans, useTranslation } from "gatsby-plugin-react-i18next";
import React, { useEffect, useState } from "react";
import { LoadCanvasTemplate, loadCaptchaEnginge, validateCaptcha } from "react-simple-captcha";

export default function Contacts() {
  const captchaLength = 6;
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [contactFormValidated, setContactFormValidated] = useState(false);
  const [sendingEmail, setSendingEmail] = useState(false);

  useEffect(() => loadCaptchaEnginge(captchaLength, "transparent", "#212529", "numbers"), []);

  function submitContactForm(event) {
    event.preventDefault();
    event.stopPropagation();

    if (validateCaptcha(captcha) === true) {
      alert("Captcha Matched");
      setSendingEmail(true);
    } else {
      alert("Captcha Does Not Match");
      setCaptcha("");
    }

    setContactFormValidated(true);
  }

  function onCaptchChanges(event) {
    if (contactFormValidated !== true) {
      setContactFormValidated(true);
    }
    setCaptcha(event.target.value);
  }

  return (
    <>
      <h1 className="my-5 text-center">
        <Trans>CONTACTS</Trans>
      </h1>
      <div id="google-map" className="google-map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2996.802195038721!2d-8.151198470798358!3d41.31316656573228!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x63c49e3af418babc!2sAud%C3%A1cia+%7C+Mobili%C3%A1rio+Industrial!5e0!3m2!1spt-PT!2sus!4v1491835682580"
          width="100%"
          height="500"
          frameBorder="0"
          allowFullScreen
          title="Google Map"
        ></iframe>
        <div id="googleMaps" className="google-map-container"></div>
      </div>

      <div className="row">
        <div className="col-lg">
          <form className={contactFormValidated === true ? "was-validated" : ""}>
            <h3 className="mt-3 mb-4">
              <Trans>FORM</Trans>
            </h3>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                <Trans>NAME</Trans>
              </label>
              <input type="text" value={name} className="form-control" id="name" onChange={e => setName(e.target.value)} required />
              <div className="invalid-feedback">
                <Trans>FORM_INDICATE_VALID_NAME</Trans>
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                value={email}
                className="form-control"
                id="email"
                onChange={e => setEmail(e.target.value)}
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                aria-describedby="nameHelpBlock"
                required
              />
              <div className="invalid-feedback">
                <Trans>FORM_INDICATE_VALID_EMAIL</Trans>
              </div>
              {contactFormValidated !== true && (
                <div id="nameHelpBlock" className="form-text">
                  <Trans>FORM_INDICATE_VALID_EMAIL_HELP</Trans>
                  <i className="small"> ( email@provider.com )</i>
                </div>
              )}
            </div>
            <div className="mb-3">
              <label htmlFor="message" className="form-label">
                <Trans>MESSAGE</Trans>
              </label>
              <textarea
                value={message}
                onChange={e => setMessage(e.target.value)}
                className="form-control"
                id="message"
                rows="3"
                required
                minLength={10}
                aria-describedby="messageHelpBlock"
              ></textarea>
              <div className="invalid-feedback">
                <Trans>FORM_MESSAGE_MIN_10_CHARS</Trans>
              </div>
              {contactFormValidated !== true && (
                <div id="messageHelpBlock" className="form-text">
                  <Trans>FORM_MESSAGE_MIN_10_CHARS_HELP</Trans>
                </div>
              )}
            </div>
            <LoadCanvasTemplate reloadText={t("REFRESH_CAPTCHA")} reloadColor="var(--bs-primary)" />
            <div>
              <input
                type="text"
                value={captcha}
                className="form-control mt-1"
                id="captcha"
                onChange={onCaptchChanges}
                style={{ width: "150px" }}
                required
                minLength={captchaLength}
                maxLength={captchaLength}
                aria-describedby="captchaHelpBlock"
              />
              <div className="invalid-feedback">
                <Trans>FORM_INDICATE_VALID_CAPTCHA</Trans>
              </div>

              {contactFormValidated !== true && (
                <div id="captchaHelpBlock" className="form-text">
                  <Trans>FORM_INDICATE_CAPTCHA_HELP</Trans>
                </div>
              )}
            </div>
            <button
              type="button"
              className="btn btn-primary mt-3"
              onClick={submitContactForm}
              disabled={!(name && email && message?.length >= 10 && captcha?.length >= 6 && !sendingEmail)}
            >
              {sendingEmail && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
              <Trans>SEND</Trans>
            </button>
          </form>
        </div>
        <div className="col-lg-1"></div>
        <div className="col-lg">
          <div className="d-xxl-none d-xl-none d-lg-none mt-5"></div>
          <dl className="row mt-4">
            <dt className="col-12">
              <Trans>ADDRESS</Trans>
            </dt>
            <dd className="col-12">
              Via Nacional 15, Edifício Portas de Santiago, No. 111, Loja 1 Figueiró
              <br />
              4615-180 Amarante | Portugal
            </dd>

            <dt className="col-12">
              <Trans>PHONE</Trans>
            </dt>
            <dd className="col-12">
              +351 919 374 005
              <br />
              +351 917 615 483
            </dd>

            <dt className="col-12">Email</dt>
            <dd className="col-12">
              <a href="mailto:geral@audacia.pt" className="link-footer">
                geral@audacia.pt
              </a>
              &nbsp;
            </dd>

            <dt className="col-12">GPS</dt>
            <dd className="col-12">41.311914, -8.149518 | N 41° 18' 42.8904'', W 8° 8' 58.2648''</dd>
          </dl>
        </div>
      </div>
    </>
  );
}
